import { PlantsView } from '@/features/plants/components/shared/plants-view.tsx';
import { PlantsList } from '@/features/plants/components/shared/plants-list.tsx';
import { MyProfileAvatar } from '@/components/my-profile-avatar';
import { QuickActionsNav } from '@/components/quick-actions-nav';

const Plants = () => {
  return (
    <div className="w-full gap-2 overflow-auto px-4 pt-3 pb-8 sm:px-6">
      <div className="flex flex-col gap-6">
        <div className="flex h-[45px] items-center justify-between">
          <h1 className="text-xl font-bold sm:text-2xl">Plants</h1>
          <div className="flex gap-2">
            <QuickActionsNav />
            <MyProfileAvatar />
          </div>
        </div>
        <div>
          <div className="flex flex-col gap-4">
            <PlantsView />
            <PlantsList />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Plants;
